import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import {
  BACKEND_EDUCATION_LIST_KEY,
  OTHER_TUITION,
  BACKEND_EDUCATION_GOAL_API,
} from '../ChildrenInfoWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../Profile/Accounts_react/AccountsUtils';
import InputAge from '../../InputAge/InputAgeView';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';

import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';

import { yearsValidator } from '../ChildrenInfoWorkflowValidator';

const YearsSavingView = ({
  workflowId,
  branch,
  clientId,
  store,
  educationGoal,
  onPostProcess,
  selectedEducationType,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    canSkip={selectedEducationType !== OTHER_TUITION && !educationGoal.IsSpecificCollege}
    id="ChildAge"
  >
    <Validation workflowId={workflowId} validationId={`${BACKEND_EDUCATION_LIST_KEY}.Years`} />

    <h2>How many years will they attend?</h2>
    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputAge
            isUnder
            placeholderClassName="adv-workflows-placeholder-large"
            placeholder="Years"
            className="xsm text-center"
            value={educationGoal.Years}
            id="adv-years"
            onChange={event => {
              const saveYearsSavingFor = inputTextChanged(
                clientId,
                store(workflowId),
                `${BACKEND_EDUCATION_LIST_KEY}.Years`,
              );
              saveYearsSavingFor(event);
            }}
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={yearsValidator(educationGoal.Years)}
      validationId={`${BACKEND_EDUCATION_LIST_KEY}.Years`}
      workflowId={workflowId}
      backendKey={BACKEND_EDUCATION_GOAL_API}
      onPostProcess={data => onPostProcess(data, educationGoal)}
      validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'school_years_completed')}
    />
  </AdvWorkflowStep>
);

YearsSavingView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  selectedEducationType: PropTypes.number.isRequired,
  educationGoal: PropTypes.shape({
    Years: PropTypes.string,
  }).isRequired,
  onPostProcess: PropTypes.func.isRequired,
};

export default YearsSavingView;
